import supabase from './supabase';
import { recordEngagement } from './visit-tracking';

// Sharing must still work if stats is offline or not configured yet.
export async function recordShare(method) {
  void recordEngagement("share");
  try {
    await supabase.from('app_share_events').insert({ method });
  } catch {
    // Stats is best effort; never retry and risk counting an action twice.
  }
}
